// common configurations of GS App

import {
  getBaseEndpointForAPIGateway,
  getBaseEndpointForMiniAppCore
} from '@/models/api/apiEnv';

export const APP_RUN_ENV = Object.freeze({
  APP: 'APP',
  H5: 'H5'
});

// Remote images links' prefix
export const MEDIA_CENTRAL_LINKS = Object.freeze({
  NEW_IMAGE_URL: 'https://m.media-amazon.com/images/G/28/NewApp/',
  OLD_IMAGE_URL:
    'https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/',
  PREFIX_IMAGE_URL: 'https://m.media-amazon.com/images/G/28/',
  MEDIA_CENTRAL_DOMAIN: 'https://m.media-amazon.com/'
});

// clientId
export const CLIENT_ID = 'GSApp';

// Index of each main pages in Tab bar
export const TABBAR_INDEX = Object.freeze({
  GATEWAY: 0,
  CATEGORY: 1,
  CART: 2,
  YOURACCOUNT: 3
});

// Application layer protocols
export const APPLICATION_LAYER_PROTOCOLS = Object.freeze({
  HTTP: 'http',
  HTTPS: 'https'
});

// API response status code
export const API_RESPONSE_STATUS_CODE = Object.freeze({
  SUCCESS: 200,
  FAILURE: 500,
  UNAUTHORIZED: 401
});

// API endpoints
export const API_ENDPOINTS = Object.freeze({
  EMTCSLP_EXTERNAL_APIGATEWAY_PROD: getBaseEndpointForAPIGateway(),
  EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA: getBaseEndpointForAPIGateway('gamma'),
  MINIAPP_PROD: getBaseEndpointForMiniAppCore(),
  MINIAPP_GAMMA: getBaseEndpointForMiniAppCore('gamma')
});

// Time format
export const TIME_FORMAT = Object.freeze({
  BY_HOUR: 'HH:mm:ss',
  BY_HOUR_MINUTE: 'HH:mm'
});

// timeout configs for Axios
export const AXIOS_CONFIG = Object.freeze({
  TIMEOUT_DEFAULT: 10000,
  TIMEOUT_MAX: 60000
});

// Badges types used by asin item
export const ASIN_ITEM_BADGES_LIST = [
  'US_BADGE',
  'UK_BADGE',
  'JP_BADGE',
  'GE_BADGE'
];

// Time conversion e.g: millisecond to second
export const TIME_CONVERSION_UNIT = 1000;
